module.exports = __webpack_public_path__ + "img/9788949120966.265f5c14.jpg";